import { Button, Col, Icon, Modal, Row, Spin, Switch, Table, Tag, Tooltip } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import { Constant } from '../../config';
import { GatewayColor, GatewayName } from '../../config/gateway';
import GatewayCountryForm from '../GatewayCountry/form';
import MyModal from '../Modal';

const ButtonGroup = Button.Group;

const modalName = 'gateway-country';

class GatewayCountryModal extends Component {
  state = {
    loading: false,
    dataSource: [],
    flagStatusToggle: {},
    current_data: {
      region_code: undefined,
      member_id: 0,
      gateway: [],
    },
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
    filteredCountry : []
  };

  columns = [
    {
      title: 'ประเทศ',
      dataIndex: 'country_name',
      render: (text) => {
        if (text === 'NONE') text = 'Default';

        return <span style={{ fontWeight: 'bold' }}>{text}</span>;
      },
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'gateway',
      render: (text, record) => {
        let rtn = [];
        for (let i = 0; i < record.gateway.length; i++) {
          const v = record.gateway[i];

          rtn.push(
            <Tag key={i} color={GatewayColor(v.gateway_detail.key_name)}>
              {GatewayName(v.gateway_detail.key_name)}
            </Tag>,
          );
        }

        return rtn;
      },
    },
    {
      title: 'เปิด / ปิด',
      dataIndex: 'status',
      render: (text, record) => {
        return (
          <Switch
            checkedChildren={<Icon type="check" />}
            unCheckedChildren={<Icon type="close" />}
            checked={this.state.flagStatusToggle[record.region_code]}
            onChange={(e) => this.toggleStatus(e, record.region_code, record.member_id)}
          />
        );
      },
    },
    {
      title: 'ดำเนินการ',
      dataIndex: 'id',
      render: (text, record) => {
        if (!record.region_code) return '';

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="แก้ไข">
              <Button
                icon="edit"
                onClick={() =>
                  this._edit(record.region_code, record.member_id, record.gateway)
                }
              />
            </Tooltip>
            <Tooltip placement="top" title="ลบ">
              <Button
                type="danger"
                icon="delete"
                onClick={() => this._delete(record.region_code, record.member_id)}
              />
            </Tooltip>
          </ButtonGroup>
        );
      },
    },
  ];
  currentPage = 1;
  currentSearch = '';
  limit = 10;
  totalRows = 0;

  componentDidUpdate = async (prevProps, prevState) => {
    const { data: pd } = prevProps;
    const { data: d, countryList } = this.props;

    if (
      d &&
      d.memberId &&
      typeof d.memberId !== 'undefined' &&
      d.memberId !== pd.memberId &&
      d.modalName === modalName
    ) {
      const dataSource = await this._getList(
        this.currentPage,
        this.limit,
        this.currentSearch,
        d.memberId,
      );

      //filter exist country
      let tmpCountry = []
      if (dataSource.length > 0) {
        const countryCode = [];
        for (const gateway of dataSource) {
            countryCode.push(gateway.region_code)
        }

        tmpCountry = countryList.filter((c) => !countryCode.includes(c.region_code))
      }else{
        tmpCountry = countryList
      }

      this.setState({
        loading: false,
        dataSource,
        flagStatusToggle: this.setFlagStatusToggle(dataSource),
        filteredCountry : tmpCountry
      });
    }
  };

  toggleStatus = (f, region_code = '', member_id = 0) => {
    if (!region_code) return;
    if (region_code === 'NONE' && member_id === 0) {
      window.location.reload();
      return;
    }

    let textConfirm = 'ปิดการใช้งาน';
    let url = Constant.GATEWAY_COUNTRY_API_DISABLE_API;
    if (f) {
      textConfirm = 'เปิดการใช้งาน';
      url = Constant.GATEWAY_COUNTRY_API_ENABLE_API;
    }

    MyModal.confirm(
      `ยืนยัน ${textConfirm} ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true });

        try {
          await axios({
            url: url.replace('[id]', 0),
            data: { region_code, member_id },
            method: 'PUT',
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
              'Content-Type': 'application/json',
            },
          });

          MyModal.success(`${textConfirm} สำเร็จ`);

          let tmp = this.state.flagStatusToggle;
          tmp[region_code] = f;
          this.setState({ flagStatusToggle: tmp, loading: false });
        } catch (e) {
          console.log(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
        }
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  changePage = async (page, limit) => {
    this.setState({ loading: true });
    this.currentPage = page;
    this.limit = limit;

    const dataSource = await this._getList(
      page,
      limit,
      this.currentSearch,
      this.props.data.memberId,
    );

    this.setState({
      dataSource,
      flagStatusToggle: this.setFlagStatusToggle(dataSource),
      loading: false,
    });
  };

  setFlagStatusToggle = (d) => {
    let rtn = {};
    for (let i = 0; i < d.length; i++) {
      rtn[d[i].region_code] = d[i].status === 'enabled';
    }

    return rtn;
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        'ยืนยันบันทึกข้อมูล ใช่หรือไม่',
        '',
        async (f) => {
          if (!f) return;

          this.setState({ loading: true });

          let opt = {
            url: Constant.GATEWAY_COUNTRY_API,
            method: this.state.flagCreateOrUpdateForm ? 'POST' : 'PUT',
            data: values,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
              'Content-Type': 'application/json',
            },
          };
          let resp;
          let modeTxt = this.state.flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
          let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          let eFlag = false;
          let eMsgDetail = '';

          try {
            resp = await axios(opt);
          } catch (e) {
            resp = e.response;
          }

          if (!resp.data) {
            eFlag = true;
          } else if (resp.data.error) {
            eFlag = true;
            let e = resp.data.error;
            eMsgDetail = `[${e.code}] ${e.name}`;
          }

          if (eFlag) {
            MyModal.error(eMsg, eMsgDetail, () => {
              window.location.reload();
            });
            return;
          }

          if (this.state.flagCreateOrUpdateForm) form.resetFields();

          MyModal.success(`${modeTxt}ข้อมูลสำเร็จ`, '', async () => {
            const dataSource = await this._getList(
              this.currentPage,
              this.limit,
              this.currentSearch,
              this.props.data.memberId,
            );

            this.setState({
              loading: false,
              visibleFormModal: false,
              dataSource,
              flagStatusToggle: this.setFlagStatusToggle(dataSource),
            });
          });
        },
        'ยืนยัน',
        'ยกเลิก',
      );
    });
  };

  formHandleCancel = () => {
    this.setState({
      visibleFormModal: false,
      current_data: {
        region_code: undefined,
        member_id: 0,
        gateway: [],
      },
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  _getList = async (page = 1, limit = 10, search = '', memberID = 0) => {
    const url =
      Constant.GATEWAY_COUNTRY_API +
      '?page=' +
      page +
      '&limit=' +
      limit +
      '&search=' +
      search +
      `&member_id=` +
      memberID;
    const opt = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    this.totalRows = resp.data.total_rows || 0;

    const d = resp.data.data;
    let rtn = [];

    if (d.length < 1) return [];

    let index = 0;
    let groupRegionCode = d[0].region_code;
    rtn.push({
      key: index + 1,
      country_name: d[0].country_detail ? d[0].country_detail.name : d[0].region_code,
      region_code: d[0].region_code,
      gateway: [],
      status: d[0].status,
      id: d[0].id,
      member_id: d[0].member_id,
    });

    for (let i = 0; i < d.length; i++) {
      let v = d[i];

      if (groupRegionCode !== v.region_code) {
        groupRegionCode = v.region_code;
        index++;

        rtn.push({
          key: index + 1,
          country_name: v.country_detail ? v.country_detail.name : v.region_code,
          region_code: v.region_code,
          gateway: [],
          status: v.status,
          id: v.id,
          member_id: v.member_id,
        });
      }

      rtn[index].gateway.push(v);
    }

    return rtn;
  };

  _create = () => {
    if (this.props.data && this.props.data.memberId)
      this.setState({
        current_data: {
          region_code: undefined,
          member_id: this.props.data.memberId,
          gateway: [],
        },
        flagCreateOrUpdateForm: true,
        visibleFormModal: true,
      });
  };

  _edit = (region_code = '', member_id = 0, gateway = []) => {
    if (!region_code) return;

    let tmp = [];
    for (let i = 0; i < gateway.length; i++) {
      tmp.push(gateway[i].gateway_id);
    }

    this.setState({
      current_data: {
        region_code,
        member_id,
        gateway: tmp,
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
    });
  };

  _delete = (region_code = '', member_id = 0) => {
    if (!region_code) return;
    if (region_code === 'NONE' && member_id === 0) {
      window.location.reload();
      return;
    }

    MyModal.confirm(
      `คุณต้องการลบรายการนี้ ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true });

        try {
          await axios({
            url: Constant.GATEWAY_COUNTRY_API_DELETED_API.replace('[id]', 0),
            data: { region_code, member_id },
            method: 'PUT',
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
              'Content-Type': 'application/json',
            },
          });

          MyModal.success('ลบรายการสำเร็จ');
          const dataSource = await this._getList(
            this.currentPage,
            this.limit,
            this.currentSearch,
            this.props.data.memberId,
          );

          this.setState({
            dataSource,
            flagStatusToggle: this.setFlagStatusToggle(dataSource),
            loading: false,
          });
        } catch (e) {
          console.log(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
        }
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  render() {
    const propsTable = {
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
    };
    const { visible, onCancel, data, gatewayList } = this.props;
    let title =
      'Gateway Configuration Route' +
      (data && data.memberName ? ' ของ ' + data.memberName : '');

    return (
      <Modal
        className="my-layout"
        visible={visible}
        maskClosable={false}
        onCancel={onCancel}
        title={title}
        width={800}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            ปิด
          </Button>,
        ]}
        style={{ top: 20 }}
      >
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Row className="utility-bar">
            <Col span={12}>
              <Button icon="plus-circle" onClick={() => this._create()}>
                เพิ่ม
              </Button>
            </Col>
            <Col span={12}></Col>
          </Row>
          <Row className="utility-bar-mobile">
            <Button icon="plus-circle" onClick={() => this._create()}>
              เพิ่ม
            </Button>
          </Row>
          <Row className="utility-bar-mobile"></Row>
          <Table {...propsTable} />
        </Spin>
        <GatewayCountryForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.visibleFormModal}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          countryList={this.state.filteredCountry}
          gatewayList={gatewayList}
          loading={this.state.loading}
        />
      </Modal>
    );
  }
}

export default GatewayCountryModal;



// WEBPACK FOOTER //
// ./src/containers/User/GatewayCountryModal.js